class SlashCtaCounter extends HTMLElement {
  connectedCallback() {
    this.numberEl = this.querySelector('[data-counter-number]');
    if (!this.numberEl) return;

    this.target = parseInt(this.dataset.target, 10) || 0;
    this.duration = parseInt(this.dataset.duration, 10) || 2000;
    this.hasAnimated = false;

    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      this.setValue(this.target);
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.animate();
          }
        });
      },
      {
        threshold: 0.25,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }

  setValue(value) {
    this.numberEl.textContent = Math.round(value).toLocaleString();
  }

  animate() {
    const startTime = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - startTime) / this.duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.setValue(this.target * eased);

      if (progress < 1) {
        this.animationFrame = requestAnimationFrame(tick);
      } else {
        this.setValue(this.target);
      }
    };

    this.animationFrame = requestAnimationFrame(tick);
  }
}

if (!customElements.get('slash-cta-counter')) {
  customElements.define('slash-cta-counter', SlashCtaCounter);
}
